module.exports = __webpack_public_path__ + "static/media/outlined-square.45f794f4.svg";